module.exports = __webpack_public_path__ + "static/img/v76Bg-p.c80afd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v76Bg-p.png
// module id = eOAs
// module chunks = 1